<div class="kr-app-container" kr-resource><KryptonLayerManager z-reference="10000" attach="body"></KryptonLayerManager></div>